import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const parentRoute = computed(() => route.meta?.parent)

return (_ctx: any,_cache: any) => {
  const _component_c_tile_btn = _resolveComponent("c-tile-btn")!

  return (_unref(parentRoute))
    ? (_openBlock(), _createBlock(_component_c_tile_btn, {
        key: 0,
        "data-id": "page-back-btn",
        icon: "inri-arrow",
        class: "rotate-180",
        "tooltip-right": _ctx.$t('inri.navigate_back'),
        to: { name: _unref(parentRoute) }
      }, null, 8, ["tooltip-right", "to"]))
    : _createCommentVNode("", true)
}
}

})